import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RelatorioService } from 'src/app/services/http/relatorio.service';
import { Observable } from 'rxjs';
import { Cliente } from 'src/app/models/cliente';
import { Unidade } from 'src/app/models/Unidade';

@Component({
  selector: 'app-relatorio-consultas-realizadas',
  templateUrl: './relatorio-consultas-realizadas.component.html',
  styleUrls: ['./relatorio-consultas-realizadas.component.scss']
})
export class RelatorioConsultasRealizadasComponent implements OnInit {

  path: string = '';

  requestData = {
    filter: {
      // dataInicio: null,
      // dataFim: null,
      dataInicio: new Date(),
      dataFim: new Date(),
      listaCliente: [],
      listaUnidade: [],
      individual: false,
      unidadeDireta: false,
    },
    sorting: {
      id: 'desc',
      documento: '',
      nomeFantasia: '',
      usuario: '',
      produto: '',
      data: '',
      entrada: '',
      cobrar: '',
      resgatada: '',
      laudo: ''
    },
    page: 1,
    per_page: 10,
  };

  relatorioRequest = '';
  tableLoading: boolean = true;
  listaResultado: [] = [];
  listaCliente = [];
  listaUnidade = [];
  total: number = 0;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  pesquisaCliente = (text: Observable<string>) =>
  text.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.listaCliente.filter(
      c => c.nomeFantasia.toLowerCase().indexOf(term.toLowerCase()) > -1 && !c.checked
    ).slice(0, 10))
  );
  inputClienteFormat = (c: Cliente) => c.nomeFantasia;
  clienteSelecionado: string;

  pesquisaUnidade = (text: Observable<string>) =>
  text.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.listaUnidade.filter(
      c => c.nomeFantasia.toLowerCase().indexOf(term.toLowerCase()) > -1 && !c.checked
    ).slice(0, 10))
  );
  inputUnidadeFormat = (c) => c.nomeFantasia;
  unidadeSelecionado: string;

  constructor(private activedRoute: ActivatedRoute, private relatorioService: RelatorioService) {
    this.activedRoute.data.pipe(first()).subscribe(data => {
      this.path = data.tipoRelatorio;

      switch (this.path) {
        case 'unidades':
          this.requestData.filter.unidadeDireta = false;
          this.relatorioService.listaUnidade().then(r => this.listaUnidade = r);
          break;

        case 'unidades-diretas':
          this.requestData.filter.unidadeDireta = true;
          this.relatorioService.listaUnidade().then(r => this.listaUnidade = r);
          break;

        case 'minha-unidade':
        default:
          this.requestData.filter.individual = true;
          break;
      }

      let now = new Date();
      this.setDataInicio({ day: now.getDate(), month: now.getMonth() + 1, year: now.getFullYear() }, false);
      this.setDataFim({ day: now.getDate(), month: now.getMonth() + 1, year: now.getFullYear() }, false);

      this.tableLoading = false;
      // this.getResultado();

    });
  }

  ngOnInit() {
    this.requestData.filter.dataInicio.setDate(1);
  }

  getResultado() {
    this.tableLoading = true;
    let jsonData = {
      ...this.requestData,
      sorting: this.removeEmpty({ ...this.requestData.sorting }),
      filter: {
        ...this.requestData.filter,
        dataFim: this.requestData.filter.dataFim.getTime(),
        dataInicio: this.requestData.filter.dataInicio.getTime(),
      }
    }

    this.relatorioService.gerarRelatorio(jsonData)
      .then(r => {
        this.listaResultado = r.data.lista || [];
        this.total = r.data.total || 0;

      }).catch(e => {
        console.error('erro o gerar relatório: ', e);
        this.listaResultado = [];
        this.total = 0;

      }).finally(() => {
        this.tableLoading = false;
      });
  }

  pageChange() {
    this.getResultado();
  }

  setPageSize(size) {
    this.requestData.per_page = size;
    this.getResultado();
  }

  setDataInicio(date, update = true) {
    date = this.requestData.filter.dataInicio.getTime(),
    this.pesquisaDataInicio = date;
    if (update) this.getResultado();
  }

  setDataFim(date, update = true) {
    date = this.requestData.filter.dataFim.getTime(),
    this.pesquisaDataFim = date;
    if (update) this.getResultado();
  }


  setTableOrder() {
    this.getResultado();
  }

  removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  addFiltroCliente(selected) {
    if (!selected.item.checked) {
      selected.item.checked = true;
      this.requestData.filter.listaCliente = this.listaCliente.filter(c => c.checked);
      // this.getResultado();
    }
    this.clienteSelecionado = '';
    selected.preventDefault();
  }
  removeFiltroCliente(cliente) {
    cliente.checked = false;
    this.requestData.filter.listaCliente = this.listaCliente.filter(c => c.checked);
    // this.getResultado();
  }

  addFiltroUnidade(selected) {
    if (!selected.item.checked) {
      selected.item.checked = true;
      this.requestData.filter.listaUnidade = this.listaUnidade.filter(c => c.checked);
      // this.getResultado();
    }
    this.unidadeSelecionado = '';
    selected.preventDefault();
  }

  removeFiltroUnidade(unidade) {
    unidade.checked = false;
    this.requestData.filter.listaUnidade = this.listaUnidade.filter(c => c.checked);
    // this.getResultado();
  }

  download() {
    //this.tableLoading = true;
    let jsonData = {
      ...this.requestData,
      sorting: this.removeEmpty({ ...this.requestData.sorting }),
      filter : { ...this.requestData.filter,
        dataFim: this.requestData.filter.dataFim.getTime(),
        dataInicio: this.requestData.filter.dataInicio.getTime(),
      },
    }
    this.relatorioService.gerarRelatorioXls(jsonData).then(data => {
      let file = new FileReader();
      file.onload = () => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        }else {
          const link = document.createElement('a');
          link.href = file.result as string;
          link.download = 'Relatorio Consultas.xlsx';
          link.addEventListener('click', () => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(file.result as string); 
          })
          document.body.appendChild(link);
          link.click();
        }
      }
      file.readAsDataURL(data);
    }, error => {
      console.error('Erro ao gerar Excel do relatório');
      console.error(error);
    });
  }

}
